import { IServiceAppointments } from '@/service/types'
import { theme } from '@/styles/theme'
import { Box, Paper, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import { ServiceDetails } from '../../../components/service-details'
import { StepCircle } from '../../../components/step-circle'

interface SelectServicesStepProps {
  services: IServiceAppointments[]
  selectedServices: string[]
  handleSelectService: (selected: IServiceAppointments) => void
}

const SelectServicesStep = (props: SelectServicesStepProps) => {
  const { services, selectedServices, handleSelectService } = props

  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Paper elevation={0} sx={styles.paper}>
      <StepCircle number="1" />

      <Typography variant="h6" marginTop={matches ? 0 : 1}>
        Válaszd ki a szűréseket, amikre jelentkezni szeretnél.
      </Typography>

      <Box sx={styles.container} paddingLeft={matches ? 0 : 1}>
        {services.map(({ service, hours }) => {
          const isSelected = selectedServices.includes(service)
          let serviceStyles = {}

          if (isSelected) {
            serviceStyles = styles.serviceSelected
          }

          return (
            <ServiceContainerPaper
              key={service}
              elevation={1}
              sx={serviceStyles}
              onClick={() => handleSelectService({ service, hours })}
            >
              {isSelected && (
                <img
                  src="/check.svg"
                  alt="Check"
                  style={{ position: 'absolute', top: 16, right: 16 }}
                />
              )}
              <ServiceDetails service={service} />
            </ServiceContainerPaper>
          )
        })}
      </Box>
    </Paper>
  )
}

const ServiceContainerPaper = styled(Paper)(({ theme }) => ({
  width: 187,
  height: 177,
  margin: theme.spacing(1.5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  position: 'relative',
  '&:hover': {
    cursor: 'pointer',
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
  },
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0.5),
    width: 157,
    height: 147,
  },
}))

const styles = {
  paper: { padding: 3, marginY: 2, position: 'relative' },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    ml: -1.5,
    pt: 3,
  },
  serviceSelected: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
  },
}

export default SelectServicesStep
